/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};
type ReturnTuple = [vp.PartnerAccountSummaryResponse, (params: vp.PartnerAccountSummaryRequest) => void, () => void];

function useFetchPartnerAccountSummary({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.PartnerAccountSummaryRequest>({
    Year: '',
    Month: '',
  });
  const [response, setResponse] = useState<vp.PartnerAccountSummaryResponse>({
    Success: true,
    ErrorMessage: '',
    Year: '',
    Month: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  useEffect(() => {
    const sendRequest = async (requestParams: vp.PartnerAccountSummaryRequest) => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');
      const res = await api.fetchPartnerAccountSummary(requestParams, source);
      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.PartnerAccountSummaryRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: true,
        ErrorMessage: '',
        Year: '',
        Month: '',
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchPartnerAccountSummary);
